//排序
export const bubbleSort=(json,key)=>{
    for(var j=1,jl=json.length;j < jl;j++){
        var temp = json[j],
            val  = temp[key],
            i    = j-1;
        while(i >=0 && json[i][key]>val){
            json[i+1] = json[i];
            i = i-1;    
        }
        json[i+1] = temp;
        
    }
    //console.log(json);
    return json;
};
//禁止输入空格 @onkeypress="keydown"
export const keydown=(event)=>{
    if(event.keyCode == 32){
      event.returnValue = false
    }
  }